import { Params, ParamMap } from '@angular/router';
import { JobStatuses } from 'src/shared/api';

export const JOB_STATUSES_KEY = 'js';

export const toJobStatusesParams = (args: {
	jobStatuses?: string[];
}): Params => ({
	[JOB_STATUSES_KEY]: args.jobStatuses ? args.jobStatuses : undefined,
});

export const toJobStatusesListArgs = (
	paramMap: ParamMap
): { jobStatuses?: JobStatuses[] } =>
	paramMap.has(JOB_STATUSES_KEY)
		? {
				jobStatuses: paramMap.getAll(JOB_STATUSES_KEY) as JobStatuses[],
		  }
		: undefined;
